import styles from "./books.module.scss";
import m1 from "../../../../assets/images/m1.jpg";
import m2 from "../../../../assets/images/m2.jpg";
import m3 from "../../../../assets/images/m3.jpg";
import m4 from "../../../../assets/images/m4.jpg";
// ===============================================
import s1 from "../../../../assets/images/s1.jpg";
import s2 from "../../../../assets/images/s2.jpg";
import s3 from "../../../../assets/images/s3.jpg";
import s4 from "../../../../assets/images/s4.jpg";
import s5 from "../../../../assets/images/s5.jpg";
import s6 from "../../../../assets/images/s6.jpg";
import s7 from "../../../../assets/images/s7.jpg";
import s8 from "../../../../assets/images/s8.jpg";
// ==============================================
import c1 from "../../../../assets/images/c1.jpg";
import c2 from "../../../../assets/images/c2.jpg";

const Books = () => {
  const ml_data = [
    { id: 0, title: "Hands-On Machine Learning with Scikit-Learn, Keras, and TensorFlow, 2nd Edition", img: m1, link: "https://www.amazon.com/Hands-Machine-Learning-Scikit-Learn-TensorFlow/dp/1492032646/" },
    // { id: 1, title: "Machine Learning: A Probabilistic Perspective", img: m2, link: "https://www.amazon.com/Machine-Learning-Probabilistic-Perspective-Computation/dp/0262018020" },
    // { id: 2, title: "Deep Learning", img: m3, link: "https://www.amazon.com/Deep-Learning-Adaptive-Computation-Machine/dp/0262035618" },
    // { id: 3, title: "Deep Learning with PyTorch ", img: m4, link: "https://www.manning.com/books/deep-learning-with-pytorch" },
    // { id: 4, title: "Deep Learning with Python "},
    // { id: 5, title: "Artificial Intelligence : A modern approach"},
  ];

  const sw_data = [
    { id: 0, title: "", img: s1, link: "https://www.amazon.com/Clean-Code-Handbook-Software-Craftsmanship-ebook/dp/B001GSTOAM/" },
    // { id: 1, title: "", img: s2, link: "https://www.amazon.com/dp/B075LRM681/" },
    // { id: 2, title: "", img: s3, link: "https://www.amazon.com/dp/B0050JLC9Y/" },
    { id: 3, title: "", img: s4, link: "https://www.amazon.com/Primer-5th-Stanley-B-Lippman/dp/0321714113/" },
    { id: 4, title: "", img: s5, link: "https://www.amazon.com/Python-Crash-Course-Eric-Matthes-ebook/dp/B07J4521M3/" },
    // { id: 5, title: "", img: s6, link: "" },
    // { id: 6, title: "", img: s7, link: "" },
    // { id: 7, title: "", img: s8, link: "" },
  ];

  const cs_data = [
    { id: 0, title: "", img: c1, link: "https://www.amazon.com/Introduction-Algorithms-3rd-MIT-Press/dp/0262033844/" },
    { id: 1, title: "", img: c2, link: "https://www.amazon.com/Learning-SQL-Generate-Manipulate-Retrieve/dp/1492057614/" },
  ];

  const ml_list = ml_data.map((item) => {
    return (
      <div key={item.id} className={styles.bookitem}>
        <div className={styles.cover}>
          <a href={item.link} target="_blank" rel="noreferrer">
            <img src={item.img} alt={item.title} />
            <i className="far fa-link"></i>
          </a>
        </div>
      </div>
    );
  });

  const sw_list = sw_data.map((item) => {
    return (
      <div key={item.id} className={styles.bookitem}>
        <div className={styles.cover}>
          <a href={item.link} target="_blank" rel="noreferrer">
            <img src={item.img} alt={item.title} />
            <i className="far fa-link"></i>
          </a>
        </div>
      </div>
    );
  });

  const cs_list = cs_data.map((item) => {
    return (
      <div key={item.id} className={styles.bookitem}>
        <div className={styles.cover}>
          <a href={item.link} target="_blank" rel="noreferrer">
            <img src={item.img} alt={item.title} />
            <i className="far fa-link"></i>
          </a>
        </div>
      </div>
    );
  });

  return (
    <div className={styles.main}>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-14">
        <div className={styles.section}>
          <div className={styles.sectionTitle}>
            Machine Learning & Deep Learning
          </div>
          <div className={styles.sectionContent}>
            <div className="grid grid-cols-4 gap-2">{ml_list}</div>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Software Development</div>
          <div className={styles.sectionContent}>
            <div className="grid grid-cols-4 gap-2">{sw_list}</div>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Computer Science</div>
          <div className={styles.sectionContent}>
            <div className="grid grid-cols-4 gap-2">{cs_list}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Books;
